<div class="container" cdkFocusInitial aria-modal="true">
  <div mat-dialog-title class="dialog-title">
    @if (data.demobilize == true) {
      <h1>Demobilize user</h1>
    }
    @if (data.demobilize != true) {
      <h1>Mobilize user</h1>
    }
    <button mat-icon-button aria-label="close dialog" mat-dialog-close aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    @if (data.demobilize == true) {
      <p>Are you sure you want to Demobilize <b>{{data.user_name}}</b>
      from <b>{{data.report_name}}?</b></p>
    }
    @if (data.demobilize != true) {
      <p>Are you sure you want to Mobilize <b>{{data.user_name}}</b>
      back into <b>{{data.report_name}}?</b></p>
    }
  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="button-row">
      <button aria-label="Cancel" class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
      @if (data.demobilize == true) {
        <button aria-label="Update" class="usa-button remove" [mat-dialog-close]="1"
          ><fa-icon class="fa-sm"
        [icon]="faArrowRight"></fa-icon>Demobilize</button>
      }
      @if (data.demobilize != true) {
        <button aria-label="Update" class="usa-button remove" [mat-dialog-close]="1"
          ><fa-icon class="fa-sm" [icon]="faArrowLeft"></fa-icon>Mobilize</button>
        }
      </div>
    </div>
  </div>